import React from "react";
import PropTypes from "prop-types";

import { Button, Drawer, Popconfirm, Spin } from "antd";
import { CardWrapper, PageTitleWrapper, ActionItemWrapper, DrawerFooterWrapper, PageSubTitle1Wrapper, TableWrapper, PageDropDownWrapper, WarningMessage } from "./Commons.style";

import { ArrowLeftOutlined } from "@ant-design/icons";
import { useHistory } from "react-router-dom";
import { getQuestionCountMessage } from "Helpers/QuestionLimits";

export function Card(props) {
	return <CardWrapper {...props} />;
}

export function PageTitle({ titlePosition = "center", children }) {
	return <PageTitleWrapper titlePosition={titlePosition}>{children}</PageTitleWrapper>;
}

export function PageDropDown({ customStyle = {}, children }) {
	return <PageDropDownWrapper style={customStyle}>{children}</PageDropDownWrapper>;
}

export function PageSubTitle1(props) {
	return <PageSubTitle1Wrapper>{props.children}</PageSubTitle1Wrapper>;
}

export function PageWarningMessage(props) {
	return <WarningMessage>{props.children}</WarningMessage>;
}

export function QuestionCountMessage({ count, min, max, noun = "Questions", visible = true }) {
	if (!visible) {
		return null;
	}

	return <PageWarningMessage>* {getQuestionCountMessage(count, { min, max, noun })}</PageWarningMessage>;
}

export function ActionItem(props) {
	return <ActionItemWrapper {...props}>{props.children}</ActionItemWrapper>;
}

function DeleteTooltip(props) {
	return (
		<Popconfirm title="Are you sure delete this?" onConfirm={props.onConfirm} onCancel={props.onCancel} okText="Yes" cancelText="No">
			<ActionItem>{props.children}</ActionItem>
		</Popconfirm>
	);
}

DeleteTooltip.propTypes = {
	onConfirm: PropTypes.func.isRequired,
};

/* DRAWER */
function SideDrawer(props) {
	return <Drawer placement={"right"} width={450} footer={<DrawerFooter {...props} />} {...props}></Drawer>;
}

function DrawerFooter(props) {
	return (
		<DrawerFooterWrapper>
			{props.onConfirm && (
				<Button type="primary" loading={props.loading} onClick={props.onConfirm}>
					{" "}
					{props.submitText || "Submit"}{" "}
				</Button>
			)}
			<Button onClick={props.onClose}>Close</Button>
		</DrawerFooterWrapper>
	);
}

function ReturnButton(props) {
	const history = useHistory();
	return (
		<div style={{ padding: "10px 0" }}>
			<ArrowLeftOutlined onClick={() => history.goBack()} />
		</div>
	);
}

// Table
function TableContainer(props) {
	const showLoading = !!props.loading;

	return (
		<TableWrapper
			// rowClassName={(record, index) => index % 2 === 0 ? 'table-row-light' : 'table-row-dark'}
			{...props}
			loading={showLoading}
			locale={{ emptyText: props?.tableMessage ? props.tableMessage : showLoading ? "Loading..." : "No Data Available" }}
			rowKey={props?.rowKey || "id"}
		/>
	);
}
SideDrawer.propTypes = {
	title: PropTypes.string.isRequired,
	onClose: PropTypes.func.isRequired,
	visible: PropTypes.bool.isRequired,
	submitText: PropTypes.string,
};

export function SimpleLoader() {
	return (
		<CardWrapper spacing={24}>
			<div style={{ display: "flex", justifyContent: "center", alignItems: "center", minHeight: 280 }}>
				<Spin />
			</div>
		</CardWrapper>
	);
}

export { DeleteTooltip, SideDrawer, ReturnButton, TableContainer };
export { ModuleTableFallback } from "./ModuleTableFallback";
